import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'

import Overview, {OverviewProps} from './Overview'
import {selectCompanyActivationStatus} from '../../../data/company'
import {SECTION_SELLER_TRADE_PARTNERS} from '../../../constants/sections'
import {selectInputFieldsBySectionName} from '../../../modules/input-fields'
import {aFetchTasks} from '../../../data/tasks'
import {
  selectSumOfSellerTradePartnerLimits,
  selectSellerTradePartnerLimitCurrency,
  selectAnnualFundingPotentialForCompany,
} from '../../../data/seller-trade-partners'
import {
  selectTradePartnerSummaryData,
  selectAreAllBsrsDeclined,
} from '../../seller-trade-partners/seller-trade-partner-summary/selector'
import {ROUTE_COMPANY_TRADE_PARTNERS} from '../../../routes/constants'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  OverviewProps,
  | 'activationStatus'
  | 'showBuyers'
  | 'sumOfSellerTradePartnerLimits'
  | 'annualFundingPotential'
  | 'tradePartnerLimitCurrency'
  | 'sellerTradePartnerSummary'
  | 'areAllBsrsDeclined'
> => ({
  activationStatus: selectCompanyActivationStatus(state),
  showBuyers: selectInputFieldsBySectionName(state, SECTION_SELLER_TRADE_PARTNERS).length > 0,
  sumOfSellerTradePartnerLimits: selectSumOfSellerTradePartnerLimits(state),
  annualFundingPotential: selectAnnualFundingPotentialForCompany(state),
  tradePartnerLimitCurrency: selectSellerTradePartnerLimitCurrency(state),
  sellerTradePartnerSummary: selectTradePartnerSummaryData(state).slice(0, 4) || [],
  areAllBsrsDeclined: selectAreAllBsrsDeclined(state),
})

const mapDispatchToProps = {
  fetchTasks: aFetchTasks,
  redirectToBuyers: (): any => aPush(ROUTE_COMPANY_TRADE_PARTNERS),
}

export default connect(mapStateToProps, mapDispatchToProps)(Overview)
